import React from "react";

export function PlanFeature({ children }) {
  return (
    <span className="rounded-full border border-solid border-[#E4E4EE] bg-[#F8F8FC] px-3 py-1 text-[12px] leading-none text-[#5A5A72]">
      {children}
    </span>
  );
}
